import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "flex flex-col relative" }
const _hoisted_2 = { class: "flex flex-row justify-between pt-1 pb-3" }
const _hoisted_3 = { class: "text-gray-lp-600 font-normal text-base" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-row gap-x-4"
}
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = {
  key: 0,
  class: "w-300px absolute z-50 mt-2 right-0 top-full"
}
const _hoisted_7 = { class: "bg-white border border-gray-lp-400 rounded-md overflow-x-show" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "my-3 ml-4 font-semibold text-base " }, "Bandara asal", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "border-t border-gray-lp-400" }, null, -1)
const _hoisted_10 = { class: "my-3 mx-4" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "my-3 ml-4 font-semibold text-base " }, "Bandara tujuan", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "border-t border-gray-lp-400" }, null, -1)
const _hoisted_13 = { class: "my-3 mx-4" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "border-t border-gray-lp-400" }, null, -1)
const _hoisted_15 = { class: "flex z-50 sticky bottom-0 pb-2 mx-4 bg-white" }
const _hoisted_16 = { class: "w-6/12 pl-2 pr-1 mt-2" }
const _hoisted_17 = { class: "w-6/12 pr-2 pl-1 mt-2" }
const _hoisted_18 = {
  key: 0,
  class: "w-300px absolute z-50 mt-2 right-0 top-full"
}
const _hoisted_19 = { class: "bg-white border border-gray-lp-400 rounded-md overflow-x-show" }
const _hoisted_20 = { class: "my-3 ml-4 font-semibold text-base " }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "border-t border-gray-lp-400" }, null, -1)
const _hoisted_22 = { class: "my-3 mx-4" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "w-full flex flex-row justify-between" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "border-t border-gray-lp-400" }, null, -1)
const _hoisted_28 = { class: "flex z-50 sticky bottom-0 pb-2 mx-4 bg-white" }
const _hoisted_29 = { class: "w-6/12 pl-2 pr-1 mt-2" }
const _hoisted_30 = { class: "w-6/12 pr-2 pl-1 mt-2" }
const _hoisted_31 = {
  key: 1,
  class: "border-t border-gray-lp-400 py-2 justify-items-end"
}
const _hoisted_32 = { class: "w-1/3" }
const _hoisted_33 = {
  key: 1,
  class: "grid w-full gap-3"
}
const _hoisted_34 = { class: "overflow-x-auto space-y-3 px-1 pb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_StatusHandler = _resolveComponent("StatusHandler")!
  const _component_ScheduleCardV2 = _resolveComponent("ScheduleCardV2")!
  const _component_CargoTableSttSection = _resolveComponent("CargoTableSttSection")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("span", _hoisted_3, "Menampilkan " + _toDisplayString(_ctx.error || _ctx.isLoading || _ctx.isEmpty ? "0" : "semua") + " kargo pesawat ke kota tujuan Anda.", 1),
        (_ctx.error !== 'server' && _ctx.error !== 'internet' && !_ctx.isLoading)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_LpButton, {
                  title: `Bandara ${_ctx.listAirportFilterCounter}`,
                  icon: _ctx.isListAirportFilterFilled ? 'chevron-down-red' : 'chevron-down-new',
                  fontWeight: "semibold",
                  sizeIcon: "18px",
                  customClass: `border ${_ctx.isListAirportFilterFilled ? 'border-pink-lp-300 bg-pink-lp-500 text-red-lp-1500' : 'border-gray-lp-200 bg-gray-lp-1000 text-gray-lp-300'}`,
                  onClick: _cache[1] || (_cache[1] = 
              () => {
                _ctx.airportFilter = !_ctx.airportFilter
                _ctx.openFilter = false
                _ctx.localListAirportOrigin = _ctx.listAirportOrigin
                _ctx.localListAirportDestination = _ctx.listAirportDestination
              }
            )
                }, null, 8, ["title", "icon", "customClass"]),
                (_ctx.airportFilter && !_ctx.isLoading)
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _hoisted_9,
                        _createVNode("div", _hoisted_10, [
                          _createVNode("div", null, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mapOriginAirport, (item, index) => {
                              return (_openBlock(), _createBlock("div", {
                                key: index,
                                class: "w-full flex p-field-checkbox mt-1.5 justify-between"
                              }, [
                                _createVNode("label", {
                                  for: `airportOrigin${index}`,
                                  class: "ml-2.5 text-sm text-black-lp-300"
                                }, _toDisplayString(item), 9, ["for"]),
                                _createVNode(_component_Checkbox, {
                                  id: `airportOrigin${index}`,
                                  name: "airportOrigin",
                                  value: item,
                                  modelValue: _ctx.localListAirportOrigin,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.localListAirportOrigin = $event))
                                }, null, 8, ["id", "value", "modelValue"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _hoisted_11,
                        _hoisted_12,
                        _createVNode("div", _hoisted_13, [
                          _createVNode("div", null, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mapDestinationAirport, (item, index) => {
                              return (_openBlock(), _createBlock("div", {
                                key: index,
                                class: "w-full flex p-field-checkbox mt-1.5 justify-between"
                              }, [
                                _createVNode("label", {
                                  for: `airportDestination${index}`,
                                  class: "ml-2.5 text-sm text-black-lp-300"
                                }, _toDisplayString(item), 9, ["for"]),
                                _createVNode(_component_Checkbox, {
                                  id: `airportDestination${index}`,
                                  name: "airportDestination",
                                  value: item,
                                  modelValue: _ctx.localListAirportDestination,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.localListAirportDestination = $event))
                                }, null, 8, ["id", "value", "modelValue"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createVNode("div", null, [
                          _hoisted_14,
                          _createVNode("div", _hoisted_15, [
                            _createVNode("div", _hoisted_16, [
                              _createVNode(_component_LpButton, {
                                color: "white",
                                textColor: "red-lp-100",
                                title: "Reset",
                                customClass: "border border-white",
                                outline: "",
                                isWidthFull: "",
                                fontWeight: "semibold",
                                textSize: "14",
                                onClick: _cache[4] || (_cache[4] = 
                        () => {
                          _ctx.airportFilter = false;
                          _ctx.localListAirportOrigin = []
                          _ctx.localListAirportDestination = []
                          _ctx.listAirportOrigin = []
                          _ctx.listAirportDestination = []
                        }
                      )
                              })
                            ]),
                            _createVNode("div", _hoisted_17, [
                              _createVNode(_component_LpButton, {
                                color: "red-lp-100",
                                textColor: "white",
                                title: "Terapkan",
                                isWidthFull: "",
                                fontWeight: "semibold",
                                textSize: "14",
                                onClick: _cache[5] || (_cache[5] = 
                        () => {
                          _ctx.listAirportOrigin = _ctx.localListAirportOrigin
                          _ctx.listAirportDestination = _ctx.localListAirportDestination
                          _ctx.airportFilter = false
                        }
                      )
                              })
                            ])
                          ])
                        ]),
                        _renderSlot(_ctx.$slots, "default")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_LpButton, {
                id: "filter_sort_arr_dep_flight_schedule",
                title: _ctx.selectedFlightSortName,
                iconLeft: _ctx.flightTime ? 'sort-filter-red' : 'sort-filter-gray',
                customClass: `border border-gray-lp-200 ${_ctx.flightTime ? 'bg-pink-lp-500 text-red-lp-1500' : 'bg-gray-lp-1000 text-gray-lp-300'}`,
                sizeIcon: "18px",
                fontWeight: "semibold",
                onClick: _cache[6] || (_cache[6] = 
            () => {
              _ctx.openFilter = !_ctx.openFilter
              _ctx.isSortFilter = true
              _ctx.airportFilter = false
            }
          )
              }, null, 8, ["title", "iconLeft", "customClass"]),
              _createVNode(_component_LpButton, {
                id: "filter_sort_arr_dep_flight_schedule",
                title: `Transit ${_ctx.transitFilterCounter}`,
                iconLeft: _ctx.isTransitFilterFilled ? '' : 'plane-booking-gray',
                icon: _ctx.isTransitFilterFilled ? 'chevron-down-red' : 'chevron-down-new',
                customClass: `border ${_ctx.isTransitFilterFilled ? 'border-pink-lp-300 bg-pink-lp-500 text-red-lp-1500' : 'border-gray-lp-200 bg-gray-lp-1000 text-gray-lp-300'}`,
                sizeIcon: "18px",
                fontWeight: "semibold",
                onClick: _cache[7] || (_cache[7] = 
            () => {
              _ctx.openFilter = !_ctx.openFilter
              _ctx.isSortFilter = false
              _ctx.airportFilter = false
            }
          )
              }, null, 8, ["title", "iconLeft", "icon", "customClass"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.openFilter && !_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, [
              _createVNode("div", _hoisted_20, _toDisplayString(_ctx.isSortFilter ? "Urutkan" : "Transit"), 1),
              _hoisted_21,
              _createVNode("div", _hoisted_22, [
                (_ctx.isSortFilter)
                  ? (_openBlock(), _createBlock("div", _hoisted_23, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.arrivalAndDepartureOptions, (option) => {
                        return (_openBlock(), _createBlock("div", {
                          key: option.value,
                          class: "flex flex-col gap-y-4 mx-2 my-4"
                        }, [
                          _createVNode("div", _hoisted_24, [
                            _createVNode("label", {
                              for: `radio-${option.value}`,
                              class: "cursor-pointer"
                            }, _toDisplayString(option.name), 9, ["for"]),
                            _createVNode(_component_RadioButton, {
                              id: `radio-${option.value}`,
                              name: "flight-time",
                              value: option.value,
                              modelValue: _ctx.flightTime,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.flightTime = $event)),
                              onChange: _cache[9] || (_cache[9] = 
                    () => {
                      _ctx.openFilter = false
                    }
                  )
                            }, null, 8, ["id", "value", "modelValue"])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_25, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.transitOptions, (item, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: index,
                          class: "w-full flex p-field-checkbox mt-1.5 justify-between"
                        }, [
                          _createVNode("label", {
                            for: `transit${index}`,
                            class: "ml-2.5 text-sm text-black-lp-300"
                          }, _toDisplayString(item.name), 9, ["for"]),
                          _createVNode(_component_Checkbox, {
                            id: `transit${index}`,
                            name: "transit",
                            value: item.value,
                            modelValue: _ctx.localTransitNumber,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.localTransitNumber = $event))
                          }, null, 8, ["id", "value", "modelValue"])
                        ]))
                      }), 128))
                    ]))
              ]),
              (!_ctx.isSortFilter)
                ? (_openBlock(), _createBlock("div", _hoisted_26, [
                    _hoisted_27,
                    _createVNode("div", _hoisted_28, [
                      _createVNode("div", _hoisted_29, [
                        _createVNode(_component_LpButton, {
                          color: "white",
                          textColor: "red-lp-100",
                          title: "Reset",
                          customClass: "border border-white",
                          outline: "",
                          isWidthFull: "",
                          fontWeight: "semibold",
                          textSize: "14",
                          onClick: _cache[11] || (_cache[11] = 
                  () => {
                    _ctx.openFilter = false;
                    _ctx.localTransitNumber = []
                    _ctx.transitNumber = []
                  }
                )
                        })
                      ]),
                      _createVNode("div", _hoisted_30, [
                        _createVNode(_component_LpButton, {
                          color: "red-lp-100",
                          textColor: "white",
                          title: "Terapkan",
                          isWidthFull: "",
                          fontWeight: "semibold",
                          textSize: "14",
                          onClick: _cache[12] || (_cache[12] = 
                  () => {
                    _ctx.transitNumber = _ctx.localTransitNumber
                    _ctx.openFilter = false
                  }
                )
                        })
                      ])
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_31, [
                    _createVNode("div", _hoisted_32, [
                      _createVNode(_component_LpButton, {
                        color: "white",
                        textColor: "red-lp-100",
                        title: "Reset",
                        customClass: "border border-white",
                        isWidthFull: "",
                        outline: "",
                        fontWeight: "semibold",
                        textSize: "14",
                        onClick: _ctx.resetFlightTime
                      }, null, 8, ["onClick"])
                    ])
                  ])),
              _renderSlot(_ctx.$slots, "default")
            ])
          ]))
        : _createCommentVNode("", true)
    ], 512), [
      [_directive_click_outside, 
      () => {
        if (_ctx.openFilter) {
          _ctx.openFilter = false;
        }
        if (_ctx.airportFilter) {
          _ctx.airportFilter = false
        }
      }
    ]
    ]),
    (_ctx.isLoading || _ctx.error || _ctx.isEmpty)
      ? (_openBlock(), _createBlock(_component_StatusHandler, {
          key: 0,
          icon: _ctx.iconStatus,
          customHeaderMessage: _ctx.headerMessage,
          customMessage: _ctx.bodyMessage,
          buttonAction: !_ctx.isLoading,
          isLoading: _ctx.isLoading,
          buttonTitle: _ctx.buttonTitle,
          buttonIconLeft: _ctx.buttonIconLeft,
          buttonTextColor: "white",
          customIconClass: `${_ctx.isEmpty && 'h-36 w-36'} mt-6`,
          onAction: _ctx.onActionButtonClicked
        }, null, 8, ["icon", "customHeaderMessage", "customMessage", "buttonAction", "isLoading", "buttonTitle", "buttonIconLeft", "customIconClass", "onAction"]))
      : (_openBlock(), _createBlock("div", _hoisted_33, [
          _createVNode("div", _hoisted_34, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredFlightSchedules, (flightData, index) => {
              return _withDirectives((_openBlock(), _createBlock(_component_ScheduleCardV2, {
                key: flightData.orderId,
                dataFlight: flightData,
                index: index,
                totalFlight: _ctx.data.length
              }, null, 8, ["dataFlight", "index", "totalFlight"])), [
                [_vShow, _ctx.isFilterFlight(flightData)]
              ])
            }), 128))
          ])
        ])),
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_CargoTableSttSection)
    ], 512), [
      [_vShow, false]
    ])
  ], 64))
}